import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { LOGIN_ROUTE } from "../../config/RoutesConstants"
import { 
  Container, 
  Box,
  IconButton,
  Typography, 
  Tab,
  Tabs,
} from "@material-ui/core"
import { withTheme } from "@material-ui/core/styles"
import BackIcon from '@material-ui/icons/ArrowBackRounded';
import Util, { ERROR, SUCCESS } from '../../common/Util'
import { actionGetStatsByClient, actionGetStatsByClientDetail, actionGetStatsByRRPPDetail } from "../../actions/StatsActions"
import { actionGetPlaces } from "../../actions/PlaceActions"
import {
  actionGetTags
} from "../../actions/TagActions";

import moment from "moment"
// import ClearIcon from '@material-ui/icons/Backspace';
import StatsByClientTab from "./StatsByClientTab"
import StatsByClientDetail from "./StatsByClientDetail"
import StatsByEventTab from "./StatsByEventTab"
import StatsByRRPPTab from "./StatsByRRPPTab"
import StatsByRRPPDetail from "./StatsByRRPPDetail"
import StatsByEventDetail from "./StatsByEventDetail";

class Statistics extends React.PureComponent{
  constructor(props){
    super(props)
    let lastMonth = moment()
    lastMonth = lastMonth.add(-1,"month").format("YYYY-MM-DD")
    let today = moment().format("YYYY-MM-DD")
    let filter = {from:lastMonth, to:today, period:"daily", place:""}
    this.state = {count:0, rowPerPage:10, page:1, orderBy:"Qt", orderDesc:true, 
                  filter:filter, tabIndex:0, detailInitFilter:null, detailEvent:null, detailTktType:null}
    this.onChangeTab = this.onChangeTab.bind(this)
    this.onPressDetailUser = this.onPressDetailUser.bind(this)
    this.onPressDetailEvent = this.onPressDetailEvent.bind(this)
    this.onPressDetailTktType = this.onPressDetailTktType.bind(this)
    this.onPressDetailRRPP = this.onPressDetailRRPP.bind(this)
  }

  componentWillMount(){
    if(!this.props.login){
      this.props.history.replace(LOGIN_ROUTE);      
    }else{
      this.props.actionGetPlaces(null,this.getPlacesError)
      this.props.actionGetTags(null,this.getTagsError)
    }
  }

  getPlacesError(e){
    console.log("ERROR GET Places", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al listar las ubicaciones.")
  }
 
  getTagsError(e){
    console.log("ERROR GET Tags", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al listar los tags.")
  }

  onChangeTab(evt, value){
		this.setState({tabIndex:value, page:0}); 
	}

  onPressDetailUser(user, filter){
    this.props.actionGetStatsByClientDetail({...filter, tktBuyerDU:user.tktBuyerDU}, {}, ()=>{
      this.setState({detailUser:user, detailInitFilter:filter})
    },
    (e)=>{
      console.log("ERROR GET Client detail", e)
      if(!(e&&e.status&&e.status==401))
        Util.showNoty(ERROR, "Ocurrió un error al consultar el detalle.")
    })
  }

  onPressDetailEvent(event, filter){
    // console.log("onPressDetailEvent",event, filter)
    //this.props.actionGetStatsByClient({...filter, evtId:event.evtId}, {}, ()=>{
      this.setState({detailEvent:event, detailInitFilter:filter})
    // },
    // (e)=>{
    //   console.log("ERROR GET Event detail", e)
    //   if(!(e&&e.status&&e.status==401))
    //     Util.showNoty(ERROR, "Ocurrió un error al consultar el detalle.")
    // })
  }

  onPressDetailTktType(event, tktType, filter){
    // console.log("onPressDetailTktType",event, filter)
    // this.props.actionGetStatsByClient({...filter, evtId:event.evtId, tktType:tktType.id}, {}, ()=>{
      this.setState({detailEvent:event, detailTktType:tktType, detailInitFilter:filter})
    // },
    // (e)=>{
    //   console.log("ERROR GET Ticket Type detail", e)
    //   if(!(e&&e.status&&e.status==401))
    //     Util.showNoty(ERROR, "Ocurrió un error al consultar el detalle.")
    // })
  }

  onPressDetailRRPP(rrpp, filter){
    this.props.actionGetStatsByRRPPDetail({...filter, tktRrpp:rrpp.tktRrpp}, {}, ()=>{
      this.setState({detailRrpp:rrpp, detailInitFilter:filter})
    },
    (e)=>{
      console.log("ERROR GET RRPP Detail", e)
      if(!(e&&e.status&&e.status==401))
        Util.showNoty(ERROR, "Ocurrió un error al consultar el detalle.")
    })
  }


  render(){
    const { theme, handleSubmit, history, placeList, tagList} = this.props
    const { detailUser, detailEvent, detailTktType,detailInitFilter, detailRrpp } = this.state
    return (
      <Box style={theme.mainContainer}>
        <Box style={{...theme.title.container, flexDirection:"row", display:"flex"}}>
          <Box style={theme.title.backIconContainer}>
            <IconButton onClick={this.props.history.goBack} style={theme.title.backIcon}>
              <BackIcon style={{fontSize:"2.5rem"}} stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"/>
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h1">Estadísticas</Typography>
            
          </Box>
        </Box>
        <Container maxWidth={1320}>        
          <Tabs indicatorColor="primary" value={this.state.tabIndex} onChange={this.onChangeTab}>
            <Tab label="Por Cliente" />
            <Tab label="Por Evento"/>
            <Tab label="Por RRPP"/>
          </Tabs>
          {this.state.tabIndex==0&&<StatsByClientTab onPressDetail={this.onPressDetailUser} />}
          {this.state.tabIndex==1&&<StatsByEventTab onPressDetail={this.onPressDetailEvent} onPressDetailTktType={this.onPressDetailTktType}/>}
          {this.state.tabIndex==2&&<StatsByRRPPTab onPressDetail={this.onPressDetailRRPP}/>}
        </Container>
        <StatsByEventDetail event={detailEvent} 
                            tktType={detailTktType}
                            filter={detailInitFilter}
                            onClose={()=>{this.setState({detailEvent:null,detailTktType:null,detailInitFilter:null})}}/>
        <StatsByClientDetail 
                            user={detailUser}
                            filter={detailInitFilter}
                            onClose={()=>{this.setState({detailUser:null,detailInitFilter:null})}}/>
        <StatsByRRPPDetail 
                            user={detailRrpp}
                            filter={detailInitFilter}
                            onClose={()=>{this.setState({detailRrpp:null,detailInitFilter:null})}}/>
      </Box>
    )
  }
}
function mapStateToProps(store) {
  return {
    login: store.auth.login,
    statsByClient:store.stats.statsByClient 
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetStatsByClient,
      actionGetStatsByClientDetail,
      actionGetStatsByRRPPDetail,
      actionGetPlaces,
      actionGetTags
    },
    dispatch
  );
}

// Statistics.defaultProps = {
//   stats:{
//     statsTotalQtSell:50,
//     statsTotalQt:1000,
//     statsTotalAmmountProducer:22000,
//     statsTotalAmmount:27000,
//     statsTotalQtSellByRRPP:1100 //transient
//   }
// }

export default withRouter(
    withTheme(
      connect(
        mapStateToProps,
        mapDispatchToProps
      )(Statistics)
    )
  )


// WEBPACK FOOTER //
// ./src/screens/statistics/Statistics.js